module.exports = __webpack_public_path__ + "img/profile-add.0ae6eb63.svg";